import { allRoutes } from "./routes/allRoutes";
import { useRoutes } from "react-router-dom";
import DemoRoute from "./protectedRoute/demoRoute";

function App() {
  const router = useRoutes(allRoutes);

  return (
    <>
      <div>
        <div className="App">
          <DemoRoute>{router}</DemoRoute>
        </div>
      </div>
    </>
  );
}

export default App;
